// extracted by mini-css-extract-plugin
module.exports = {"container":"Snackbar_container__YtJr6"};